export const ADDITIONAL_LANGUAGES_QUERY = `
query additionalLanguages(
	$id:[QueryArgument!]) {
	entries(id:$id, site: "*") {
		uri
		url
		language
		siteHandle
	}
}`